const css = `.signed-document-dialog.p-dialog {
  width: 90vw;
  max-width: 1200px;
}
.signed-document-dialog.p-dialog .signed-document {
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex-wrap: wrap;
}
.signed-document-dialog.p-dialog .signed-document .signed-document-text section {
  margin-bottom: var(--space-6);
}
.signed-document-dialog.p-dialog .signed-document .signed-document-text section ul {
  padding-left: 48px;
  list-style-type: disc;
  font-size: var(--font-size-base);
}
.signed-document-dialog.p-dialog .signed-document .signed-document-text section h3,
.signed-document-dialog.p-dialog .signed-document .signed-document-text section h2,
.signed-document-dialog.p-dialog .signed-document .signed-document-text section p,
.signed-document-dialog.p-dialog .signed-document .signed-document-text section li {
  margin-bottom: var(--space-5);
}
.signed-document-dialog.p-dialog .signed-document .signed-document-text section a {
  font-size: var(--font-size-sm);
  text-decoration: underline;
  color: var(--text);
  overflow-wrap: break-word;
  word-break: break-word;
}
.signed-document-dialog.p-dialog .signed-document .signed-document-text.indent-text section p {
  text-indent: 32px;
}
.signed-document-dialog.p-dialog .signed-document .signed-document-form > h3 {
  width: 100%;
  margin-bottom: calc(-1 * var(--space-5));
}
.signed-document-dialog.p-dialog .signed-document .signed-document-form .guardian-section {
  width: 100%;
  border-top: 1px solid var(--surface-border);
  padding-top: 24px;
}
.signed-document-dialog.p-dialog .p-dialog-title {
  color: var(--text);
}
.signed-document-dialog.p-dialog .p-dialog-content {
  max-height: 80vh;
  overflow-y: auto;
}
.signed-document-dialog.p-dialog .no-signature-alert {
  margin: 16px 0;
}
.signed-document-dialog.p-dialog .no-signature-alert .no-signature-alert-link {
  color: var(--danger);
  text-decoration: underline;
  font-size: var(--font-size-sm);
}
.signed-document-dialog.p-dialog .consent-options {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.signed-document-dialog.p-dialog .consent-options .consent-option {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.signed-document-dialog.p-dialog .consent-options .consent-option label {
  font-weight: var(--font-weight-medium);
  display: inline-block;
  color: var(--text-muted);
}
.signed-document-dialog.p-dialog .consent-options .consent-option .consent-radio-group {
  display: flex;
  gap: 32px;
  padding: 16px;
  justify-content: center;
}
.signed-document-dialog.p-dialog .consent-options .consent-option .consent-radio-group .consent-radio {
  display: flex;
  align-items: center;
  gap: 8px;
}
.signed-document-dialog.p-dialog .consent-options .consent-option .consent-radio-group .consent-radio label {
  font-weight: var(--font-weight-regular);
}
.signed-document-dialog.p-dialog .consent-options .consent-option .consent-description {
  color: var(--text-color-secondary);
  font-size: var(--font-size-sm);
  margin: 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
